// extracted by mini-css-extract-plugin
export var bodySections = "_ai-8";
export var gray = "_ai-7";
export var green = "_ai-4";
export var iconContainer = "_ai-9";
export var iconWidgetContainer = "_ai-1";
export var phoneIcon = "_ai-2";
export var red = "_ai-5";
export var statusDot = "_ai-3";
export var widgetContainer = "_ai-0";
export var yellow = "_ai-6";